// The top bar's title slot. The shell knows which section a path is in
// (nav.ts); a page below a list — one contact, one template — knows the
// last word, and hands it up with `usePageCrumb`.

import { createContext, useContext, useEffect, useMemo, useState } from "react";
import type { ReactNode } from "react";

interface CrumbSlot {
  crumb: string | null;
  setCrumb: (crumb: string | null) => void;
}

const CrumbContext = createContext<CrumbSlot | null>(null);

export function CrumbProvider({ children }: { children: ReactNode }) {
  const [crumb, setCrumb] = useState<string | null>(null);
  const value = useMemo(() => ({ crumb, setCrumb }), [crumb]);
  return <CrumbContext.Provider value={value}>{children}</CrumbContext.Provider>;
}

export function useCrumb(): string | null {
  return useContext(CrumbContext)?.crumb ?? null;
}

/** Name the page's own last breadcrumb while it is on screen. */
export function usePageCrumb(crumb: string | null | undefined): void {
  const slot = useContext(CrumbContext);
  const setCrumb = slot?.setCrumb;
  useEffect(() => {
    if (!setCrumb) return undefined;
    setCrumb(crumb ?? null);
    return () => setCrumb(null);
  }, [crumb, setCrumb]);
}
